/** @jsx jsx */
import { jsx } from '@emotion/react';
import SelectClearIcon from '@atlaskit/icon/glyph/select-clear';
/**
 * __Clear button__
 */
const ClearButton = ({
  inputId,
  iconSize = 'small',
  label = 'Clear',
  primaryColor,
  buttonStyles,
  dataTestId,
  onClick
}) => {
  const labelId = inputId && `label--${inputId}`;
  const clearButtonId = inputId && `clear-btn--${inputId}`;
  return jsx("button", {
    "aria-labelledby": inputId ? `${clearButtonId} ${labelId}` : `${clearButtonId}`,
    css: buttonStyles,
    type: "button",
    tabIndex: -1,
    "data-testid": `${dataTestId}--clear--btn`,
    onClick: onClick
  }, jsx("span", {
    hidden: true,
    id: clearButtonId
  }, "Clear"), jsx("span", {
    style: {
      display: 'flex'
    }
  }, jsx(SelectClearIcon, {
    size: iconSize,
    label: inputId ? '' : label,
    primaryColor: primaryColor
  })));
};
export default ClearButton;